/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { Locale, LocaleKeys } from '../../../../../core/locale';
import { KeyManager } from '../../../../../core/navigation';
import { NetworkManager } from '../../../../../core/network/NetworkManager';
import {
    RootState,
    useTivoDispatch,
    useTivoSelector,
} from '../../../../../core/tivo/tivo-redux-wrapper';
import { showWhisper } from '../../../../../store/whisper/whisper.reducer';
import { AntiburnOsd } from '../../../../common';
import { NoNetworkOverlay } from '../../../../NoNetworkOverlay';
import { Whisper } from '../../../../Whisper';
import { WhisperTypes } from '../../../../Whisper/WhisperTypes';
import { SettingsTemplate } from '../../../SettingsTemplate';

import './EmptyToDoList.scss';

const EmptyToDoList: FunctionComponent = (): JSX.Element => {
    const { isActive: isAntiBurnOsdActive } = useTivoSelector(
        (state: RootState) => state.antiburnOsd,
    );

    const dispatch = useTivoDispatch();

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
        if (NetworkManager.isNetworkDisconnected()) {
            dispatch(
                showWhisper({
                    message: NetworkManager.getNetworkDisconnectedMessage(),
                    iconType: WhisperTypes.INFO,
                }),
            );
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.TODO_LIST_PAGE_HEADER_TITLE)}>
            <div className="empty-to-do-list-container">
                <div className="empty-todo-message">
                    {Locale.getString(LocaleKeys.EMPTY_TODO_LIST_MESSAGE)}
                </div>
                {isAntiBurnOsdActive && <AntiburnOsd />}
                <NoNetworkOverlay />
                <Whisper message="" />
            </div>
        </SettingsTemplate>
    );
};

export default EmptyToDoList;
